import React from "react";
import styles from "./../../assets/styles/spec/components/footer.module.scss";
import useFormatById from "src/hooks/utils/useFormatById";
import { ReactComponent as DownArrowIcon } from "src/assets/static/images/angle-down-small.svg";
import LinksGroup from "./linksGroup";

const FooterNavigationItem = ({
  id,
  header,
  openedLinkGroups,
  linkGroupButtonHandler,
  urlList,
  isMobile,
}) => {
  const f = useFormatById();

  return (
    <div className={styles["link-group"]}>
      <div className={styles["header-and-button-wrapper"]}>
        <h3>{f(header)}</h3>
        {isMobile && (
          <button
            className={openedLinkGroups.includes(id) && styles["active-button"]}
            onClick={() => linkGroupButtonHandler(id)}
          >
            <DownArrowIcon />
          </button>
        )}
      </div>

      {isMobile ? (
        <LinksGroup
          id={id}
          openedLinkGroups={openedLinkGroups}
          data={urlList}
          isMobile={isMobile}
        />
      ) : (
        !isMobile && <LinksGroup data={urlList} />
      )}
    </div>
  );
};

export default FooterNavigationItem;
